export default {
    userDetails: {
        cmsData: {},
        sdkConfig: {},
    },
    common: {
        loadingIndicator: {
            isLoading: false,
        },
    },
    session: {
        currentTheme: "DEFAULT",
    },
};
